import { render, staticRenderFns } from "./ClientPeopleAppendix.vue?vue&type=template&id=7d1dd0c8"
import script from "./ClientPeopleAppendix.vue?vue&type=script&lang=js"
export * from "./ClientPeopleAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports